module.exports = __webpack_public_path__ + "VIPH20.png?e5b46be9975a2e78f9fab423659f8f44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH20.png
// module id = 93
// module chunks = 0